import { Flex, Stack } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { AIDetectionFeature } from "./ai-detection-feature";

export const SchoolFeatures = () => {
    const { t } = useTranslation(["common"]);

    return (
        <Stack spacing={"0rem"}>
            <AIDetectionFeature />
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.schools.all-of-the-above")}</p>
            </Flex>
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.schools.dpa")}</p>
            </Flex>
            <br />
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.schools.free-trial")}</p>
            </Flex>
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.schools.multiple-users")}</p>
            </Flex>
        </Stack>
    );
};
